import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, CardTitle, Col, Row, Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getPlcSafetyTriggers, deletePlcSafetyTrigger } from '../../store/actions';

class PlcSafetyTriggerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      triggerToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingDeletePlcSafetyTrigger === false && prevProps.loadingDeletePlcSafetyTrigger === true) {
      this.props.getPlcSafetyTriggers(this.state.user);
      if (this.props.deletePlcSafetyTriggerError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deletePlcSafetyTriggerError.message || 'Error al eliminar el trigger',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(trigger) {
    this.setState({ showConfirm: true, triggerToDelete: trigger });
  }

  doDelete() {
    const { user, triggerToDelete } = this.state;
    this.props.deletePlcSafetyTrigger({ id: triggerToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { triggerList } = this.props;
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Triggers PLC Safety')}</CardTitle>
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Nombre')}</Th>
                      <Th>{this.props.t('Telegrama')}</Th>
                      <Th>{this.props.t('Acción')}</Th>
                      <Th>{this.props.t('Patrón')}</Th>
                      <Th>{this.props.t('Evento')}</Th>
                      <Th>{this.props.t('Omite si en modo trabajo')}</Th>
                      <Th>{this.props.t('Estado')}</Th>
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {triggerList.map((tr) => (
                      <tr key={tr.id}>
                        <td>
                          <span>{tr.name}</span>
                        </td>
                        <td>
                          <span>{tr.telegram_type}</span>
                        </td>
                        <td>
                          <span>{tr.action}</span>
                        </td>
                        <td>
                          <span>{tr.element_pattern}</span>
                        </td>
                        <td>
                          <span>{tr.event_name}</span>
                        </td>
                        <td>
                          {tr.skip_if_barrier_working ? (
                            <Badge color="info" pill>
                              {this.props.t('Sí')}
                            </Badge>
                          ) : (
                            <span>—</span>
                          )}
                        </td>
                        <td>
                          {tr.has_active_causes ? (
                            <Badge color="danger" pill>
                              {this.props.t('Causa activa')}
                            </Badge>
                          ) : (
                            <Badge color="success" pill>
                              {this.props.t('Libre')}
                            </Badge>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                            title="Detalle"
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/plcSafetyTriggerDetail/${tr.id}`,
                                state: tr,
                              })
                            }
                          >
                            <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                          </button>
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            disabled={tr.has_active_causes}
                            onClick={() => this.confirmDelete(tr)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Solo se puede borrar un trigger sin causas activas')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeletePlcSafetyTrigger, deletePlcSafetyTriggerError } = state.deletePlcSafetyTrigger;
  return { loadingDeletePlcSafetyTrigger, deletePlcSafetyTriggerError };
};

export default withRouter(
  connect(mapStateToProps, { getPlcSafetyTriggers, deletePlcSafetyTrigger })(withNamespaces()(PlcSafetyTriggerList)),
);
